import React, { Component } from 'react';
import { Form, Input, Col, Row, Select, Modal, DatePicker } from 'antd';

const { Option } = Select;
const FormItem = Form.Item;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: {},
    };
  }

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handleSubmit } = this.props;
    const { detail } = this.state;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const params = values;

        if (detail.uuid) {
          params.uuid = detail.uuid;
        }
        handleSubmit(params);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const ItemLayout2 = {
      labelCol: { span: 8 },
      wrapperCol: { span: 12 },
    };
    const { handleModalVisible } = this.props;
    const { detail } = this.state;

    return (
      <Modal
        title="添加联系记录"
        visible
        onCancel={() => handleModalVisible(false)}
        onOk={this.submit}
      >
        <Form onSubmit={this.submit}>
          <Row>
            <Col span={24}>
              <Col span={24}>
                <FormItem label="联系时间" {...ItemLayout2}>
                  {getFieldDecorator('date', {
                    rules: [{ required: true, message: '请填写联系方式!' }],
                  })(<DatePicker style={{ width: '100%' }} />)}
                </FormItem>
              </Col>
            </Col>
            <Col span={24}>
              <FormItem label="备注" {...ItemLayout2}>
                {getFieldDecorator('remark', {
                  initialValue: detail.remark,
                })(<Input />)}
              </FormItem>
            </Col>
            <Col span={24}>
              <FormItem label="联系方式" {...ItemLayout2}>
                {getFieldDecorator('tel', {
                  rules: [{ required: true, message: '请填写联系方式!' }],
                  initialValue: detail.tel,
                })(<Input />)}
              </FormItem>
            </Col>
            <Col span={24}>
              <FormItem label="联系类型" {...ItemLayout2}>
                {getFieldDecorator('type', {
                  rules: [{ required: true, message: '请输入预测金额!' }],
                  initialValue: detail.prediction,
                })(
                  <Select>
                    <Option key="0">到访</Option>
                    <Option key="1">电话</Option>
                  </Select>,
                )}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(BaseForm);



// WEBPACK FOOTER //
// ./src/components/crm/custom/department/ModalContact.js